import { useTranslation } from 'react-i18next';

import type { Organization } from '../../types/api';
import { CopyableId } from '../CopyableText';
import { DetailField, DetailFieldGrid } from './DetailField';
import { JsonBlock } from '../JsonBlock';
import { DetailSection } from './DetailSection';
import { OrganizationNotificationSettings } from './OrganizationNotificationSettings';

export function OrganizationDetailPanel({ organization }: { organization: Organization }) {
    const { t } = useTranslation();
    const empty = t('common.empty');

    return (
        <>
            <DetailFieldGrid>
                <DetailField label={t('fields.name')} value={organization.name} />
                <DetailField
                    label={t('fields.type')}
                    value={
                        organization.type
                            ? t(`organizationTypes.${organization.type}`, {
                                  defaultValue: organization.type,
                              })
                            : empty
                    }
                />
                <DetailField label={t('fields.country')} value={organization.country ?? empty} />
                <DetailField label={t('fields.organizationId')} value={<CopyableId id={organization.id} />} />
                <DetailField
                    label={t('fields.created')}
                    value={
                        organization.createdAt
                            ? new Date(organization.createdAt).toLocaleString()
                            : empty
                    }
                />
            </DetailFieldGrid>
            <OrganizationNotificationSettings organizationId={organization.id} />
            {organization.settings && Object.keys(organization.settings).length > 0 ? (
                <DetailSection title={t('detail.settings')}>
                    <JsonBlock value={organization.settings} />
                </DetailSection>
            ) : null}
        </>
    );
}
